import { Dropzone } from '@/view/components/Dropzone'
import { PlayCircle } from 'lucide-react'

interface VideoDropzoneProps {
  value: File | undefined
  onChange: (file: File) => void
}

export const VideoDropzone = ({ value, onChange }: VideoDropzoneProps) => {
  const getVideoSrc = (value: File | undefined) => {
    if (!value) return null
    return URL.createObjectURL(value)
  }

  return (
    <Dropzone
      dropzoneOptions={{
        accept: {
          'video/*': ['.mp4', '.webm', '.ogg'],
        },
      }}
      onDrop={(files) => {
        if (files.length) {
          onChange(files[0])
        }
      }}
      value={value ? [value] : null}
      render={() => {
        const videoSrc = getVideoSrc(value)

        return videoSrc ? (
          <video
            onClick={(e) => e.stopPropagation()}
            src={videoSrc}
            className="h-[197px] w-full overflow-hidden rounded-md object-cover"
            controls
          />
        ) : (
          <div className="flex h-[197px] w-full flex-col items-center justify-center">
            <PlayCircle size={48} strokeWidth={1} />
            <p className="text-xs">
              Arraste e solte ou clique aqui para fazer upload
            </p>
          </div>
        )
      }}
    />
  )
}
